export type ParsedPhoneNumber = {
  formatted: string
  uri: string
}

export const parsePhoneNumber = (phoneNumber: string): ParsedPhoneNumber => {
  const parsed = phoneNumber
    .replace(new RegExp(' ', 'g'), '')
    .replace(new RegExp('\\(', 'g'), '')
    .replace(new RegExp('\\)', 'g'), '')

  return {
    formatted: phoneNumber,
    uri: 'tel:' + parsed,
  }
}
